var defaultState = {
    lastId: 0,

    curSpaceId: 0,
    spaces: [{
        name: "Blank Space",
        el: [],
    }],

    el: [],
}

export default function (state=defaultState, action) {

    switch (action.type) {
        case "ADD_IMAGE":
            return Object.assign({}, state, {

                spaces: state.spaces.map((space, index) => (state.curSpaceId === index) ? {
                    ...space,
                    el: [
                        ...space.el,
                        {
                            id: state.lastId++,
                            type: "IMAGE",
                            img: action.image,
                            rotation: {x: action.x, y: action.y, z:0},
                            depth: -12,
                            drag: false,
                        }
                    ]
                } : space )

            })

        case "ADD_TEXT":

            return Object.assign({}, state, {
                spaces: state.spaces.map((space, index) => (state.curSpaceId === index) ? {
                    ...space,
                    el: [
                        ...space.el,
                        {
                            id: state.lastId++,
                            type: "TEXT",
                            text: action.text,
                            rotation: {x: action.x, y: action.y, z:0},
                            depth: -12,
                            drag: false
                        }
                    ]
                } : space )

            })

        case "MOVE_BOX":
            return Object.assign({}, state, {
                spaces: state.spaces.map((space, index) => (state.curSpaceId === index) ? {

                    ...space,
                    el: space.el.map(
                    (item, index) => (index === action.index) ?

                    {...item, depth: action.z } :

                    item )

                } : space )

            })

        case "ADD_SPACE":
            return Object.assign({}, state, {
                spaces: [
                    ...state.spaces,
                    {
                        name: action.name,
                        el: [],
                    }
                ]
            })

        case "SWITCH_SPACE":
            return Object.assign({}, state, {
                curSpaceId: action.id,
            })

        case "UPDATE_SPACE_NAME":
            return Object.assign({}, state, {
                spaces: state.spaces.map((space, index) => (action.id === index) ? {

                    ...space,
                    name: action.name,

                } : space )
            })

        case "DELETE_SPACE":
            return Object.assign({}, state, {
                spaces: (state.spaces.length > 1 && action.id !== state.spaces.length - 1) ? [
                    ...state.spaces.slice(0, action.id),
                    ...state.spaces.slice(action.id + 1),

                ] : (state.spaces.length > 1) ? [
                    ...state.spaces.slice(0, action.id),
                ]: [...state.spaces],

                curSpaceId: (state.spaces.length > 1 && action.id === state.spaces.length - 1) ?
                0 : 0,

            })

        case "REMOVE_ITEM":
            return Object.assign({}, state, {
                spaces: state.spaces.map((space, index) => (state.curSpaceId === index) ? {

                    ...space,
                    el: [
                        ...space.el.slice(0, action.index),
                        ...space.el.slice(action.index + 1)
                    ]

                } : space )

            })

        case "CLEAR_ALL":
            return Object.assign({}, state, {
                spaces: state.spaces.map((space, index) => (state.curSpaceId === index) ? {

                    ...space,
                    el: []

                } : space )
                // el: []
            })

        case "SAVE_DRAG":
            return Object.assign({}, state, {
                spaces: state.spaces.map((space, index) => (state.curSpaceId === index) ? {

                    ...space,
                    el: space.el.map( (item, index) => (index === action.index) ? {
                        ...item,
                        rotation: {x: action.x, y: action.y, z: 0}
                    } : item )

                } : space )

            })

        case "CAMERA_ROTATION_CHANGE":
            return Object.assign({}, state, {

                spaces: state.spaces.map((space, index) => (state.curSpaceId === index) ? {

                    ...space,
                    el: space.el.map( (item, index) => (item.drag) ? {
                        ...item,
                        rotation: {x: action.x, y: action.y, z: 0}
                    } : item )

                } : space )

            })

        case "URL_LOADED":
            return Object.assign({}, state, action.data)

        default:
            return state
    }

}



// WEBPACK FOOTER //
// ./src/reducers/scene-items.js